import{a as n}from"./chunk-RAAYCPUM.js";function i(...e){return n(a,e)}function a(e,o){let r={};for(let[y,t]of e.entries())r[t]=o(t,y,e);return r}export{i as a};
